import React from "react";
import footerData from "../util/data/footer_data.json";
import { LuFacebook } from "react-icons/lu";
import {
  SlSocialTwitter,
  SlSocialInstagram,
  SlSocialYoutube,
} from "react-icons/sl";

const { data } = footerData;
const Footer = () => {
  return (
    <footer className="w-full bg-slate-50 text-md text-start">
      <div className="lg:w-4/5 w-5/6 mx-auto max-w-7xl  ">
        <div className="lg:flex item-start justify-between gap-5 border-b-2 lg:py-20 py-10">
          <div className="lg:w-1/2 w-full text-left">
            <h2 className="lg:text-2xl text-xl">TasteBites</h2>
            <p className="lg:w-3/4">
              Founded in 2015, Your Daily Dish started as a small blog dedicated
              to sharing family recipes and has since grown into a go-to
              culinary resource. With a focus on diverse, easy-to-make dishes,
              we inspire home cooks worldwide to explore new flavors and create
              memorable meals every day.
            </p>
          </div>
          <div className=" lg:py-0 py-5 lg:w-1/2 flex justify-between px-5">
            {data.map((elem, index) => {
              const { title, links } = elem;
              return (
                <div key={index}>
                  <h3 className="lg:text-xl text-lg">{title}</h3>
                  <ul className="space-y-2 py-2">
                    {links.map((item, idx) => (
                      <li key={idx}>
                        <a href={item.url}>{item.value}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>

        <div className="text-sm text-gray-500 sm:flex items-center py-5 justify-between w-11/12 text-center sm:space-y-0 space-y-5">
          <p>@ All Rights Reserved</p>
          <div className="flex gap-5 items-center justify-center">
            <LuFacebook size={20} />
            <SlSocialTwitter size={20} />
            <SlSocialInstagram size={18} />
            <SlSocialYoutube size={22} />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
